'use client'
import React from 'react'

type Props = {
  children: React.ReactNode
}

type State = {
  hasError: boolean
  error: any
  componentStack?: string | null
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error }
  }

  componentDidCatch(error: any, info: React.ErrorInfo) {
    console.error('Caught by ErrorBoundary', error, info)

    this.setState({
      componentStack: info.componentStack,
    })
  }

  render() {
    if (
      this.state.hasError &&
      window &&
      window.location.origin.includes('app-users-staging.malekcloud.com')
    ) {
      return (
        <div style={{ padding: 20 }}>
          <h2>⚠️ خطا در یکی از کامپوننت‌ها رخ داده</h2>

          <h4 style={{ marginTop: 12 }}>🧩 Component Stack</h4>
          <pre style={{ whiteSpace: 'pre-wrap', direction: 'ltr' }}>
            {this.state.componentStack}
          </pre>

          <h4 style={{ marginTop: 12 }}>💥 Error</h4>
          <pre style={{ whiteSpace: 'pre-wrap', direction: 'ltr' }}>
            {String(this.state.error?.message || this.state.error)}
          </pre>
        </div>
      )
    }

    return this.props.children
  }
}
